import type { ReactNode } from 'react';

import { useLocation } from 'react-router';
import { useMemo, useState, useEffect, createContext } from 'react';

import { SESSION_STORAGE_KEYS } from 'src/utils/constants';

export interface HistoryContextState {
  prevLocation: string | null;
}

export const HistoryContext = createContext<HistoryContextState | undefined>(undefined);

export const HistoryProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();

  // Initialize from sessionStorage if available
  const [prevLocation, setPrevLocation] = useState<string | null>(() =>
    sessionStorage.getItem(SESSION_STORAGE_KEYS.PREVIOUS_LOCATION)
  );
  const [currentLocation, setCurrentLocation] = useState<string>(location.pathname);

  useEffect(() => {
    if (location.pathname !== currentLocation) {
      // Update state
      setPrevLocation(currentLocation);
      // Persist to sessionStorage
      sessionStorage.setItem(SESSION_STORAGE_KEYS.PREVIOUS_LOCATION, currentLocation);
    }
    setCurrentLocation(location.pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const value = useMemo(() => ({ prevLocation }), [prevLocation]);

  return <HistoryContext.Provider value={value}>{children}</HistoryContext.Provider>;
};
